import PropTypes from 'prop-types'
import PlanBenefitGroup from 'model/insurancePlans/planBenefitGroup/planBenefitGroup'
import { initArray } from 'model/helpers'

class PlanBenefitCategory {
  constructor(init) {
    this._id = init.id
    this._groups = initArray(init, ['groups', 'nodes'], PlanBenefitGroup)
    this._name = init.name
    this._navigation_only = init.navigation_only
    this._plan_level = init.plan_level
    this._search_terms = init.search_terms
    this._description = init.description
    this._position = init.position
  }

  static shape = {
    id: PropTypes.number,
    groups: PropTypes.arrayOf(PropTypes.instanceOf(PlanBenefitGroup)),
    name: PropTypes.object,
    navigation_only: PropTypes.bool,
    plan_level: PropTypes.bool,
    search_terms: PropTypes.string,
    description: PropTypes.string,
    position: PropTypes.number
  }

  get id() {
    return this._id
  }

  get groups() {
    return this._groups || []
  }

  get name() {
    return this._name || ''
  }

  get navigation_only() {
    return this._navigation_only
  }

  get plan_level() {
    return this._plan_level
  }

  get search_terms() {
    return this._search_terms || ''
  }

  get description() {
    return this._description || ''
  }

  get position() {
    return this._position || ''
  }
}

export default PlanBenefitCategory
